import { etatRealisation } from '@gsm/partage';
import type { TonPastille } from './Pastille';

/** Libellés et tons des statuts d'ordre, communs à tous les écrans. */
const STATUTS: Record<string, { libelle: string; ton: TonPastille }> = {
  BROUILLON: { libelle: 'Brouillon', ton: 'neutre' },
  A_VALIDER: { libelle: 'À valider', ton: 'attente' },
  VALIDE: { libelle: 'Validé', ton: 'interface' },
  TRANSMIS: { libelle: 'Transmis', ton: 'interface' },
  DENOUE: { libelle: 'Dénoué', ton: 'succes' },
  REJETE: { libelle: 'Rejeté', ton: 'refus' },
  ANNULE: { libelle: 'Annulé', ton: 'neutre' },
};

export interface OrdreAffichable {
  statut: string;
  mode: string;
  quantiteDemandee: string | null;
  montantDemande: string | null;
  quantiteRealisee?: string | null;
  montantRealise?: string | null;
}

/**
 * Statut lu par l'utilisateur : un ordre dénoué dit aussi ce qui a été servi —
 * « Dénoué partiel » quand une unité de plus tenait dans la demande,
 * « Dénoué non servi » quand rien n'a été réalisé.
 */
export function statutOrdre(o: OrdreAffichable): { libelle: string; ton: TonPastille } {
  if (o.statut === 'DENOUE') {
    const etat = etatRealisation({
      mode: o.mode,
      quantiteDemandee: o.quantiteDemandee,
      montantDemande: o.montantDemande,
      quantiteRealisee: o.quantiteRealisee ?? null,
      montantRealise: o.montantRealise ?? null,
    });
    if (etat === 'PARTIEL') return { libelle: 'Dénoué partiel', ton: 'attente' };
    if (etat === 'NON_SERVI') return { libelle: 'Dénoué non servi', ton: 'neutre' };
  }
  return STATUTS[o.statut] ?? { libelle: o.statut, ton: 'neutre' };
}

/** Libellé d'un statut seul, pour les filtres. */
export const libelleStatutOrdre = (statut: string) => STATUTS[statut]?.libelle ?? statut;
